'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactSlidedown = require('react-slidedown');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _PlanScorecardSourceData = require('./PlanScorecardSourceData.css');

var _PlanScorecardSourceData2 = _interopRequireDefault(_PlanScorecardSourceData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanScorecardSourceData = (_dec = (0, _reactCssModules2.default)(_PlanScorecardSourceData2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecardSourceData, _Component);

  function PlanScorecardSourceData(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardSourceData);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanScorecardSourceData.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardSourceData)).call(this, props));

    _this.state = {
      showSourceData: false,
      planId: props.planId,
      planData: props.planData,
      planOptions: props.planOptions
    };
    return _this;
  }

  (0, _createClass3.default)(PlanScorecardSourceData, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showSourceData = _state.showSourceData,
          planId = _state.planId,
          planData = _state.planData,
          planOptions = _state.planOptions;
      //

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'button',
          {
            styleName: 'section-slidedown-button',
            onClick: function onClick(e) {
              _this2.setState({
                showSourceData: !showSourceData
              });
            }
          },
          _react2.default.createElement(
            'h2',
            { styleName: 'section-slidedown-label' },
            'Source data and methodology'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'section-slidedown-icon' },
            _react2.default.createElement(_components.LinkIcon, {
              faclass: showSourceData ? 'fa-angle-up' : 'fa-angle-down'
            })
          )
        ),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          showSourceData ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              { styleName: 'scorecard-methodology-link c' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.howitworks,
                  title: 'How it works',
                  transparentbutton: true
                },
                'Methodology',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'sublede' },
              'The primary source data for the retirement plan sustainability scorecards are ',
              _react2.default.createElement(
                'b',
                null,
                'Form 5500 filings'
              ),
              '. These documents were downloaded from the ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.links.dol5500search,
                  title: 'U.S. Department of Labor Form 5500 search',
                  xstrong: true
                },
                'U.S. Department of Labor Form 5500 search'
              ),
              '. If further documentation from the company was available, those documents are also included here.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'sublede-bullets' },
              planData.files && planData.files.length > 0 ? _react2.default.createElement(
                'ul',
                null,
                planData.files.map(function (e, i) {
                  // e = [name, path]
                  return _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: 'https://iyv-charts.s3.us-west-2.amazonaws.com/retirement-plans/' + planId + '/' + e[1],
                        xstrong: true,
                        targetBlank: true,
                        title: e[0]
                      },
                      e[0],
                      _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-file-pdf-o' })
                    )
                  );
                })
              ) : null
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'plan-option-card' },
              _react2.default.createElement(
                'div',
                { styleName: 'table-strong' },
                'Form 5500 source data'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'table-disclaimer' },
                'The table below represents the plan data that was used to calculate the scorecard results, sourced from the documents above.'
              ),
              _react2.default.createElement(
                'table',
                { styleName: 'full-row-table' },
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    'tr',
                    { styleName: 'dtls-tbl-row c' },
                    _react2.default.createElement(
                      'th',
                      { styleName: 'dtls-tbl-lbl' },
                      'Plan option'
                    ),
                    _react2.default.createElement(
                      'th',
                      { styleName: 'dtls-tbl-val' },
                      'Fund type'
                    ),
                    planData.allocations.default === 0 ? null : _react2.default.createElement(
                      'th',
                      { styleName: 'dtls-tbl-val' },
                      'USD$ invested by plan'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  /* source data */
                  planOptions.all.map(function (e, i) {
                    console.log(e);
                    console.log(e.assets);
                    return _react2.default.createElement(
                      'tr',
                      {
                        styleName: 'dtls-tbl-row',
                        key: 'dtls-tbl-row-' + i
                      },
                      _react2.default.createElement(
                        'td',
                        { styleName: 'dtls-tbl-lbl' },
                        e.label
                      ),
                      _react2.default.createElement(
                        'td',
                        { styleName: 'dtls-tbl-val' },
                        e.fund_type
                      ),
                      e.assets === 0 ? null : _react2.default.createElement(
                        'td',
                        { styleName: 'dtls-tbl-val r' },
                        _format2.default.money(e.assets, false, 'USD', false, 0)
                      )
                    );
                  })
                )
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null)
          ) : null
        )
      );
    }
  }]);
  return PlanScorecardSourceData;
}(_react.Component), _class2.propTypes = {
  planId: _react.PropTypes.string.isRequired,
  planData: _react.PropTypes.object.isRequired,
  planOptions: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = PlanScorecardSourceData;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardSourceData/PlanScorecardSourceData.js
// module id = 1427
// module chunks = 0